import React from "react";
import { useLang } from "../i18n";

const CLIENTS = [
  { name: "Coca-Cola", domain: "coca-cola.com" },
  { name: "Petrobras", domain: "petrobras.com.br" },
  { name: "Gerdau", domain: "gerdau.com" },
  { name: "Braskem", domain: "braskem.com.br" },
  { name: "Cargill", domain: "cargill.com" },
  { name: "BASF", domain: "basf.com" },
  { name: "Vale", domain: "vale.com" },
  { name: "Sabesp", domain: "sabesp.com.br" },
  { name: "Comgás", domain: "comgas.com.br" },
  { name: "ISA Energia", domain: "isaenergiabrasil.com.br" },
  { name: "Compagas", domain: "compagas.com.br" },
  { name: "Método", domain: "metodoengenharia.com.br" },
];

const LogoItem = ({ c }) => (
  <div
    className="shrink-0 mx-8 lg:mx-12 flex items-center justify-center h-14 w-36 lg:w-44"
    data-testid={`client-${c.name.toLowerCase().replace(/\s+/g, "-")}`}
    title={c.name}
  >
    <img
      src={`https://logo.clearbit.com/${c.domain}`}
      alt={c.name}
      className="max-h-12 max-w-full object-contain client-logo"
      onError={(e) => {
        e.currentTarget.outerHTML = `<span class="font-display text-2xl text-gt-cream/60 whitespace-nowrap uppercase tracking-wider">${c.name}</span>`;
      }}
    />
  </div>
);

export default function Clients() {
  const { t } = useLang();
  return (
    <section id="clients" data-testid="clients-section" className="py-24 md:py-32 border-t border-gt-cream/8 relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 mb-14">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7">
            <div className="section-eyebrow mb-6">
              <span className="gt-eyebrow">{t.clients.eyebrow}</span>
            </div>
            <h2 className="gt-display text-gt-cream text-4xl md:text-6xl lg:text-7xl">
              {t.clients.title_a} <span className="block text-gt-cream/55 gt-display-light">{t.clients.title_em}</span>
            </h2>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <p className="text-base md:text-lg text-gt-ink/75 leading-relaxed">{t.clients.subtitle}</p>
          </div>
        </div>
      </div>

      {/* marquee */}
      <div className="relative overflow-hidden">
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-gt-bg to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-gt-bg to-transparent z-10 pointer-events-none" />
        <div className="gt-marquee-track items-center">
          {[...CLIENTS, ...CLIENTS].map((c, i) => (<LogoItem c={c} key={i} />))}
        </div>
      </div>
      <div className="relative overflow-hidden mt-8">
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-gt-bg to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-gt-bg to-transparent z-10 pointer-events-none" />
        <div className="gt-marquee-track items-center" style={{ animationDirection: "reverse", animationDuration: "46s" }}>
          {[...CLIENTS.slice().reverse(), ...CLIENTS.slice().reverse()].map((c, i) => (<LogoItem c={c} key={i} />))}
        </div>
      </div>
    </section>
  );
}
